import React from 'react';

const Disclaimer = () => {
  return (
    <div className="min-h-screen bg-white dark:bg-gray-900">
      <div className="container max-w-4xl mx-auto px-4 py-8">
        {/* Header avec alerte */}
        <div className="bg-red-50 dark:bg-red-900/20 border-l-4 border-red-500 p-6 mb-8">
          <h1 className="text-4xl font-bold mb-4 text-red-900 dark:text-red-200">
            ⚠️ Avertissement Médical
          </h1>
          <p className="text-xl font-semibold text-red-800 dark:text-red-300">
            IMPORTANT - À LIRE ATTENTIVEMENT
          </p>
        </div>

        {/* Message principal */}
        <section className="mb-8">
          <div className="bg-yellow-50 dark:bg-yellow-900/20 border-2 border-yellow-400 p-6 rounded-lg">
            <p className="text-lg leading-relaxed text-gray-900 dark:text-white font-semibold mb-4">
              Les informations fournies sur Remadia Health sont exclusivement à but informatif et
              éducatif.
            </p>
            <p className="text-lg leading-relaxed text-gray-900 dark:text-white font-semibold">
              Elles ne constituent EN AUCUN CAS un avis médical, un diagnostic ou une prescription.
            </p>
          </div>
        </section>

        {/* Ce service ne remplace pas */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4 text-gray-800 dark:text-gray-200">
            Ce service ne remplace pas
          </h2>
          <div className="bg-gray-50 dark:bg-gray-800 p-6 rounded-lg">
            <ul className="space-y-3 text-gray-700 dark:text-gray-300">
              <li className="flex items-start">
                <span className="text-red-500 mr-3 text-xl">✗</span>
                <span>Une consultation médicale auprès d'un professionnel de santé qualifié</span>
              </li>
              <li className="flex items-start">
                <span className="text-red-500 mr-3 text-xl">✗</span>
                <span>Un examen clinique approprié</span>
              </li>
              <li className="flex items-start">
                <span className="text-red-500 mr-3 text-xl">✗</span>
                <span>Les conseils personnalisés de votre médecin traitant</span>
              </li>
              <li className="flex items-start">
                <span className="text-red-500 mr-3 text-xl">✗</span>
                <span>Une prise en charge médicale d'urgence</span>
              </li>
            </ul>
          </div>
        </section>

        {/* En cas d'urgence */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4 text-gray-800 dark:text-gray-200">
            🚨 En cas d'urgence médicale
          </h2>
          <div className="bg-red-50 dark:bg-red-900/30 border-2 border-red-500 p-6 rounded-lg">
            <p className="font-bold mb-4 text-lg text-gray-900 dark:text-white">
              N'UTILISEZ PAS CE SERVICE. Composez immédiatement :
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="bg-white dark:bg-gray-800 p-4 rounded-lg border-2 border-red-500">
                <p className="text-3xl font-bold text-red-600 dark:text-red-400 mb-2">15</p>
                <p className="font-semibold text-gray-900 dark:text-white">SAMU</p>
                <p className="text-sm text-gray-600 dark:text-gray-400">Urgence médicale</p>
              </div>

              <div className="bg-white dark:bg-gray-800 p-4 rounded-lg border-2 border-red-500">
                <p className="text-3xl font-bold text-red-600 dark:text-red-400 mb-2">18</p>
                <p className="font-semibold text-gray-900 dark:text-white">Pompiers</p>
                <p className="text-sm text-gray-600 dark:text-gray-400">Secours d'urgence</p>
              </div>

              <div className="bg-white dark:bg-gray-800 p-4 rounded-lg border-2 border-red-500">
                <p className="text-3xl font-bold text-red-600 dark:text-red-400 mb-2">112</p>
                <p className="font-semibold text-gray-900 dark:text-white">
                  Numéro d'urgence européen
                </p>
                <p className="text-sm text-gray-600 dark:text-gray-400">Toutes urgences</p>
              </div>

              <div className="bg-white dark:bg-gray-800 p-4 rounded-lg border-2 border-red-500">
                <p className="text-3xl font-bold text-red-600 dark:text-red-400 mb-2">114</p>
                <p className="font-semibold text-gray-900 dark:text-white">Urgence SMS</p>
                <p className="text-sm text-gray-600 dark:text-gray-400">
                  Personnes sourdes/malentendantes
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Utilisation de l'IA */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4 text-gray-800 dark:text-gray-200">
            Utilisation de l'intelligence artificielle
          </h2>
          <div className="bg-blue-50 dark:bg-blue-900/20 p-6 rounded-lg text-gray-700 dark:text-gray-300">
            <p className="leading-relaxed mb-4">
              Notre chatbot utilise l'intelligence artificielle (OpenAI) pour fournir des réponses.
              Bien que nous nous efforcions de garantir la qualité des informations,{' '}
              <strong>
                l'IA peut occasionnellement produire des erreurs, des inexactitudes ou des
                informations incomplètes. L'assistant IA ne propose aucun diagnostic, protocole de
                soin, ni prescription d'examens médicaux. Il fournit uniquement des informations
                d'orientation générale
              </strong>
              .
            </p>
            <p className="leading-relaxed font-semibold">
              Vérifiez TOUJOURS les informations importantes avec un professionnel de santé.
            </p>
          </div>
        </section>

        {/* Responsabilité */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4 text-gray-800 dark:text-gray-200">
            Responsabilité de l'utilisateur
          </h2>
          <div className="bg-gray-50 dark:bg-gray-800 p-6 rounded-lg">
            <p className="leading-relaxed text-gray-700 dark:text-gray-300 mb-4">
              L'utilisateur est seul responsable de l'utilisation qu'il fait des informations
              fournies par Remadia Health.
            </p>
            <p className="leading-relaxed text-gray-700 dark:text-gray-300 mb-4">
              L'éditeur décline toute responsabilité en cas de :
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4 text-gray-700 dark:text-gray-300">
              <li>Décision médicale prise uniquement sur la base des informations du site</li>
              <li>Retard dans la consultation d'un professionnel de santé</li>
              <li>Auto-médication inappropriée</li>
              <li>Mauvaise interprétation des informations</li>
              <li>Aggravation d'un état de santé</li>
            </ul>
          </div>
        </section>

        {/* Ne pas utiliser pour */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4 text-gray-800 dark:text-gray-200">
            N'utilisez PAS ce service pour
          </h2>
          <div className="bg-red-50 dark:bg-red-900/20 p-6 rounded-lg">
            <ul className="space-y-3 text-gray-700 dark:text-gray-300">
              <li className="flex items-start">
                <span className="text-red-500 mr-3 text-xl">⚠️</span>
                <span>
                  <strong>Urgences vitales</strong> - douleur thoracique, difficulté respiratoire,
                  perte de conscience, hémorragie importante
                </span>
              </li>
              <li className="flex items-start">
                <span className="text-red-500 mr-3 text-xl">⚠️</span>
                <span>
                  <strong>Diagnostic de maladies</strong> - seul un médecin peut établir un
                  diagnostic
                </span>
              </li>
              <li className="flex items-start">
                <span className="text-red-500 mr-3 text-xl">⚠️</span>
                <span>
                  <strong>Prescription de traitements</strong> - ne modifiez jamais votre traitement
                  sans avis médical
                </span>
              </li>
              <li className="flex items-start">
                <span className="text-red-500 mr-3 text-xl">⚠️</span>
                <span>
                  <strong>Situations pédiatriques urgentes</strong> - consultez rapidement un
                  pédiatre
                </span>
              </li>
              <li className="flex items-start">
                <span className="text-red-500 mr-3 text-xl">⚠️</span>
                <span>
                  <strong>Détresse psychologique</strong> - appelez le 3114 (numéro national de
                  prévention du suicide)
                </span>
              </li>
            </ul>
          </div>
        </section>

        {/* Professionnels de santé */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4 text-gray-800 dark:text-gray-200">
            Pour les professionnels de santé
          </h2>
          <div className="bg-blue-50 dark:bg-blue-900/20 p-6 rounded-lg text-gray-700 dark:text-gray-300">
            <p className="leading-relaxed mb-4">
              Les professionnels de santé utilisant Remadia Health doivent{' '}
              <strong>exercer leur propre jugement clinique</strong>.
            </p>
            <p className="leading-relaxed">
              Cet outil est une aide à la décision, pas un substitut au raisonnement médical
              professionnel. Les recommandations doivent être validées selon votre expertise et le
              contexte spécifique du patient.
            </p>
          </div>
        </section>

        {/* Sources d'information */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4 text-gray-800 dark:text-gray-200">
            Sources d'information
          </h2>
          <div className="bg-gray-50 dark:bg-gray-800 p-6 rounded-lg text-gray-700 dark:text-gray-300">
            <p className="leading-relaxed mb-4">
              Les informations de Remadia Health proviennent de sources publiques et de bases de
              données médicales. Cependant :
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Les informations médicales évoluent constamment</li>
              <li>Les recommandations peuvent varier selon les organismes</li>
              <li>Chaque situation médicale est unique</li>
            </ul>
          </div>
        </section>

        {/* Confidentialité */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4 text-gray-800 dark:text-gray-200">
            Confidentialité et données de santé
          </h2>
          <div className="bg-yellow-50 dark:bg-yellow-900/20 p-6 rounded-lg text-gray-700 dark:text-gray-300">
            <p className="leading-relaxed mb-4">
              <strong>Ne partagez pas d'informations médicales ultra-sensibles</strong> dans le
              chatbot.
            </p>
            <p className="leading-relaxed">
              Bien que vos données soient chiffrées (AES-256-GCM) et stockées de manière sécurisée,
              évitez de mentionner des détails trop personnels ou identifiables. Consultez notre{' '}
              <a href="/legal/privacy" className="text-blue-600 dark:text-blue-400 underline">
                Politique de confidentialité
              </a>
              pour en savoir plus.
            </p>
          </div>
        </section>

        {/* Message final */}
        <section className="mb-8">
          <div className="bg-green-50 dark:bg-green-900/20 border-l-4 border-green-500 p-6">
            <h3 className="font-bold text-lg mb-3 text-gray-900 dark:text-white">
              ✅ Comment utiliser Remadia Health de manière responsable
            </h3>
            <ul className="space-y-2 text-gray-700 dark:text-gray-300">
              <li>✓ Pour vous informer sur des sujets de santé généraux</li>
              <li>✓ Pour préparer vos questions avant une consultation médicale</li>
              <li>✓ Pour mieux comprendre des termes médicaux</li>
              <li>✓ Pour trouver des ressources d'urgence près de chez vous</li>
              <li>✓ Pour échanger avec d'autres aidants dans le forum communautaire</li>
            </ul>
          </div>
        </section>

        {/* Footer de la page */}
        <div className="mt-12 pt-6 border-t border-gray-300 dark:border-gray-700 text-center">
          <p className="text-sm text-gray-600 dark:text-gray-400">
            En utilisant Remadia Health, vous reconnaissez avoir lu et compris cet avertissement.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Disclaimer;
